module.exports = __webpack_public_path__ + "~@/assets/img/work.38c2653d.jpg";